import { render, staticRenderFns } from "./ImprestDimensionsDialog.vue?vue&type=template&id=6adec74a&scoped=true"
import script from "./ImprestDimensionsDialog.vue?vue&type=script&lang=js"
export * from "./ImprestDimensionsDialog.vue?vue&type=script&lang=js"
import style0 from "./ImprestDimensionsDialog.vue?vue&type=style&index=0&id=6adec74a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adec74a",
  null
  
)

export default component.exports